import React from 'react'
import { useTranslation } from 'react-i18next'
import { TooltipList } from 'packages/ui/Graph'
import { formatYAxisDroppedPackets } from '../../../../utils/graphs'
import { CustomTooltipProps } from '../../../../utils/types'
import { DOWNLOAD_COLOR, UPLOAD_COLOR } from '../../../../utils/constants'

const DroppedPacketsTooltip: React.FC<CustomTooltipProps> = ({ active, label, payload }) => {
  const { t } = useTranslation()
  if (!active || !payload || !payload.length) return null

  const droppedPacketsDownload = payload.find(({ dataKey }) => dataKey === 'droppedPacketsDownload')
  const droppedPacketsUpload = payload.find(({ dataKey }) => dataKey === 'droppedPacketsUpload')
  const dataPoint = payload[0]?.payload

  const downloadValue = typeof droppedPacketsDownload?.value === 'number' ? droppedPacketsDownload.value : undefined
  const uploadValue = typeof droppedPacketsUpload?.value === 'number' ? droppedPacketsUpload.value : undefined

  return (
    <TooltipList
      title={dataPoint?.formattedTime || label}
      list={[
        {
          color: DOWNLOAD_COLOR,
          label: t('wan.graphs.dropped_packets.download'),
          value: downloadValue !== undefined ? formatYAxisDroppedPackets(downloadValue) : '-'
        },
        {
          color: UPLOAD_COLOR,
          label: t('wan.graphs.dropped_packets.upload'),
          value: uploadValue !== undefined ? formatYAxisDroppedPackets(uploadValue) : '-'
        },
      ]}
    />
  )
}

export default DroppedPacketsTooltip